import {
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,

  SET_PASSWORD,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAIL
} from '../actions'

export const forgotPasswordFetch = (forgotPassword) => ({
  type: FORGOT_PASSWORD,
  payload: { forgotPassword }
})

export const forgotPasswordFetchSuccess = (forgotPassword) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: { forgotPassword }
})

export const forgotPasswordFetchFail = (message) => ({
  type: FORGOT_PASSWORD_FAIL,
  payload: { message }
})

export const setPasswordFetch = (setPassword) => ({
  type: SET_PASSWORD,
  payload: { setPassword }
})

export const setPasswordFetchSuccess = (setPassword) => ({
  type: SET_PASSWORD_SUCCESS,
  payload: { setPassword }
})

export const setPasswordFetchFail = (message) => ({
  type: SET_PASSWORD_FAIL,
  payload: { message }
})